// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import Vue from 'vue'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)

import App from './App'
import router from './router'
import core from './utils/core'
import filter from './utils/filter'
// footer
import scroll from "vue-seamless-scroll";
import store from './store'
import './utils/directives'
require('babel-polyfill')
import './assets/iconfont/iconfont.css'//字体图标
import './assets/font/iconfont.css'//字体图标
import exifUse from './utils/exifUse'
import bolkDown from './utils/bolkDown'
import '@/styles/element-ui.scss'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import MetaInfo from 'vue-meta-info'; // 设置 title meta 关键词
Vue.use(MetaInfo);
import axios from 'axios'
// http://www.fwzxjl.com:80
axios.defaults.baseURL = process.env.IMG_URL;  // 默认地址
// 主题颜色
import '../theme/index.css'
// 图片懒加载
import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/images/tupian.png'),
  loading: require('./assets/imagesSer/loading.gif'),
  attempt: 1
})

//调用浏览器打印
import Print from './plugins/print/Print.js'
Vue.use(Print)
// 预渲染处理 seo
router.beforeEach((to, from, next) => {
  console.log('to seo')
  let str = to.fullPath == '/service' ? '/service?id=1' : to.fullPath
  if (str.charAt(str.length - 1) == '/') {
    store.dispatch("seo/getSeo", str.substr(1, str.length - 2))
  } else {
    store.dispatch("seo/getSeo", str.substr(1))
  }
  next()
})
Vue.use(Viewer);
Viewer.setDefaults({
  navbar: false,
  toolbar:false
  // toolbar: {
  //   zoomIn: {
  //     show: true,
  //     size: 'large'
  //   },
  //   zoomOut: {
  //     show: true,
  //     size: 'large'
  //   },
  //   oneToOne: false,
  //   reset: {
  //     show: true,
  //     size: 'large'
  //   },
  //   prev: {
  //     show: true,
  //     size: 'large'
  //   },
  //   play: {
  //     show: true,
  //     size: 'large'
  //   },
  //   next: {
  //     show: true,
  //     size: 'large'
  //   },
  //   rotateLeft: {
  //     show: true,
  //     size: 'large'
  //   },
  //   rotateRight: {
  //     show: true,
  //     size: 'large'
  //   },
  //   flipHorizontal: false,
  //   flipVertical: false
  // }
});

import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  render: h => h(App),
  // components: { App },
  // template: '<App/>',
  mounted() {
    setTimeout(() => {
    	document.dispatchEvent(new Event('render-event'))
    }, 3000);
  }
})



// WEBPACK FOOTER //
// ./src/main.js